import React, { useContext } from 'react';
import LocaleContext from 'constants/localization';

const successImg = 'images/icons/tick.png';

const Required = ({valueCount, minOccurs, error}) => {
  const LS = useContext(LocaleContext);

  if (error) {
    return <span className="text-danger">{error}</span>;
  }
  if (minOccurs >= 1) {
    if (valueCount < minOccurs) {
      return <span className="text-danger">* {LS.required}</span>;
    }
    else {
      return <img src={successImg} alt='OK' title='OK' />;
    }
  }

  return null;
};

export default Required;
